import React, { useContext, useEffect, useState } from 'react';
import { Layout, Input, Button, InputNumber, Typography, Form, Checkbox} from 'antd';
import { useParams, useHistory, Link } from 'react-router-dom';
import axios from 'axios';
import swal from 'sweetalert';
import {RollbackOutlined} from '@ant-design/icons';
import { UserContext } from '../UserContext';
import './CreateForm.css'

const {Content} = Layout
const { TextArea } = Input;
const { Title } = Typography;

const CreateForm = () => {
  const history = useHistory()
  let {id} = useParams()
  const {movie_api, game_api, isMovie, user} = useContext(UserContext)
  const [trigger, setTrigger] = useState(true)
  const [form] = Form.useForm();

  // input value
  const [movieInput, setMovieInput] = useState({
    description: "",
    review: ""
  })
  const [gameInput, setGameInput] = useState({
    singlePlayer: 0,
    multiplayer: 0
  })
  
  useEffect(() => {
    if (id) {
      if (trigger) {
        if (isMovie) {
          const getData = async () => {
            try {
              const res = await axios.get(movie_api+"/"+id)
              const {title, description, year, duration, genre, rating, review, image_url} = res.data
              setMovieInput({title, description, year, duration, genre, rating, review, image_url})
              // setMovieInput(res.data)
              form.setFieldsValue(res.data)
              setTrigger(false)
            } catch(err) {
              console.log(err.response)
            }
          }
          getData()
        } else {
          const getData = async () => {
            try {
              const res = await axios.get(game_api+"/"+id)
              const {name, genre, singlePlayer, multiplayer, platform, release, image_url} = res.data
              setGameInput({name, genre, singlePlayer, multiplayer, platform, release, image_url})
              form.setFieldsValue(res.data)
              setTrigger(false)
            } catch(err) {
              console.log(err.response)
            }
          }
          getData()
        }
      }
    }
  }, [trigger])

  const onChange = (e) => {
    // console.log(e)
    
    if (isMovie) {
      setMovieInput({
        ...movieInput, ...e
      })
    } else {
      setGameInput({
        ...gameInput, ...e
      })

      if (e.singlePlayer) {
        setGameInput({
          ...gameInput, singlePlayer: 1
        })
      }

      if (e.singlePlayer === false) {
        setGameInput({
          ...gameInput, singlePlayer: 0
        })
      }
      
      if (e.multiplayer) {
        setGameInput({
          ...gameInput, multiplayer: 1
        })
      }

      if (e.multiplayer === false) {
        setGameInput({
          ...gameInput, multiplayer: 0
        })
      }
    }
  }

  const onSubmit = (e) => {
    if (isMovie) {
      if (id) {
        axios.put(movie_api+"/"+id, movieInput, {headers: {"Authorization" : "Bearer "+ user.token}})
        .then((res) => {
          console.log(res)
          swal(`Success update this movie`, {
            icon: "success",
          });
          history.push("/admin")
          form.resetFields()
        })
        .catch((err) => {
          console.log(err.response)
          swal(`Failed update this movie`, {
            icon: "error",
          });
        })
      } else {
        axios.post(movie_api, movieInput, {headers: {"Authorization" : "Bearer "+ user.token}})
          .then((res) => {
            console.log(res)
            swal(`Success add this movie`, {
              icon: "success",
            });
            form.resetFields()
          })
          .catch((err) => {
            console.log(err.response)
            swal(`Failed add this movie`, {
              icon: "error",
            });
          })
      }
    } else {
      if (!((gameInput.singlePlayer === 0) && (gameInput.multiplayer === 0))){
        if (id) {
          axios.put(game_api+"/"+id, gameInput, {headers: {"Authorization" : "Bearer "+ user.token}})
          .then((res) => {
            console.log(res)
            form.resetFields()
            setGameInput({
              singlePlayer: 0,
              multiplayer: 0
            })
            swal(`Success update this game`, {
              icon: "success",
            });
            history.push('/admin')
          })
          .catch((err) => {
            console.log(err.response)
            swal(`Failed update this game`, {
              icon: "error",
            });
          })
        } else {
          axios.post(game_api, gameInput, {headers: {"Authorization" : "Bearer "+ user.token}})
            .then((res) => {
              console.log(res)
              form.resetFields()
              setGameInput({
                singlePlayer: 0,
                multiplayer: 0
              })
              swal(`Success add this game`, {
                icon: "success",
              });
            })
            .catch((err) => {
              console.log(err.response)
              swal(`Failed add this game`, {
                icon: "error",
              });
            })
        }
      } else {
        swal(`You should enter count of player`, {
          icon: "warning",
        });
      }
    }
  }

  const movieForm = (
      <>
        <Form
          name="movie-form"
          form={form}
          labelCol={{ span: 4 }}
          wrapperCol={{ span: 8 }}
          onFinish={onSubmit}
          onValuesChange={onChange}
        >
          <Form.Item wrapperCol={{ offset: 4, span: 16 }}>
            <Title level={2}> 
              {id ? "Edit Movie Data" : "Add New Movie"} 
              {/* Add new Movie */}
            </Title>
          </Form.Item>
            
          <Form.Item wrapperCol={{ offset: 4, span: 16 }}>
            <Link to="/admin">
              <Button type="primary"><RollbackOutlined /> Go to Admin Page</Button>
            </Link>
          </Form.Item>

          <Form.Item
            label="Title"
            name="title"
            rules={[{ required: true, message: 'Please input title movie first!' }]}
          >
            <Input name="title" />
          </Form.Item>
          
          <Form.Item
            label="Year released"
            name="year"
            rules={[{ required: true, message: 'Please input year released first!' }]}
          >
            <InputNumber />
          </Form.Item>
          
          <Form.Item
            label="Duration (min)"
            name="duration"
            rules={[{ required: true, message: 'Please input duration first!' }]}
          >
            <InputNumber />
          </Form.Item>
          
          <Form.Item
            label="Genre"
            name="genre"
            rules={[{ required: true, message: 'Please input genre first!' }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Rating (1-10)"
            name="rating"
            rules={[{ required: true, message: 'Please input duration first!' }]}
          >
            <InputNumber min={1} max={10} />
          </Form.Item>

          <Form.Item
            label="Poster (url)"
            name="image_url"
            rules={[{ required: true, message: 'Please input movie poster!' }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Synopsis"
            name="description"
            rules={[{ required: false, message: 'Please input synopsis!' }]}
          >
            <TextArea showCount maxLength={250} />
          </Form.Item>

          <Form.Item
            label="Review"
            name="review"
            rules={[{ required: false, message: 'Please input genre first!' }]}
          >
            <TextArea showCount maxLength={250} />
          </Form.Item>

          <Form.Item wrapperCol={{ offset: 4, span: 16 }}>
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Form.Item>
        </Form>
      </>
    )
    
    const gameForm = (
      <>
        <Form
          name="game-form"
          form={form}
          labelCol={{ span: 4 }}
          wrapperCol={{ span: 8 }}
          onFinish={onSubmit}
          onValuesChange={onChange}
        >
          <Form.Item wrapperCol={{ offset: 4, span: 16 }}>
            <Title level={2}> 
              {id ? "Edit Game data" : "Add New Game"}
            </Title>
          </Form.Item>

          <Form.Item wrapperCol={{ offset: 4, span: 16 }}>
            <Link to="/admin">
              <Button type="primary"><RollbackOutlined /> Go to Admin Page</Button>
            </Link>
          </Form.Item>

          <Form.Item
            label="Name"
            name="name"
            rules={[{ required: true, message: 'Please input game name first!' }]}
          >
            <Input />
          </Form.Item>
          
          <Form.Item
            label="Year released"
            name="release"
            rules={[{ required: true, message: 'Please input game year released!' }]}
            
          >
            <InputNumber min={1000}/>
          </Form.Item>
          
          <Form.Item
            label="Genre"
            name="genre"
            rules={[{ required: true, message: 'Please input game genre!' }]}
            
          >
            <Input />
          </Form.Item>
          
          <Form.Item
            label="Platform"
            name="platform"
            rules={[{ required: true, message: 'Please input game platform!' }]}
          >
            <Input />
          </Form.Item>
          
          <Form.Item
            wrapperCol={{ offset: 4, span: 4 }}
            name="singlePlayer"
            valuePropName="checked"
          >
            <Checkbox>Single Player</Checkbox>
          </Form.Item>
          
          <Form.Item
            wrapperCol={{ offset: 4, span: 4 }}
            // label="Multi Player"
            name="multiplayer"
            valuePropName="checked"
          >
            {/* <InputNumber min={0} /> */}
            <Checkbox>Multi Player</Checkbox>
          </Form.Item>

          <Form.Item
            label="Poster (url)"
            name="image_url"
            rules={[{ required: true, message: 'Please input game poster!' }]}
          >
            <Input />
          </Form.Item>

          <Form.Item wrapperCol={{ offset: 4, span: 16 }}>
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Form.Item>
        </Form>
      </>
    )
  // if (isMovie) {
  //   form = <h1>ini form game</h1>
  // } else {
  //   form = <h1>ini form movie</h1>
  // }

  // // const gameForm = (
  // //   <>
  // //     {/* <Title>di sini Form game</Title> */}
  // //     <h1>ini form game</h1>
  // //   </>
  // // )
  
  // // const movieForm = (
  // //     <h1>ini form movie</h1>
  // // )

  return (
    <>
    <Layout style={{ padding: '0 24px 24px' }}>
      <Content
        className="site-layout-background"
        style={{
          padding: 24,
          margin: 0,
          minHeight: 280,
        }}
      >
        <div id="create-form">
          
          {isMovie ? movieForm : gameForm}
        </div>
      </Content>
    </Layout>
    </>
  )
}

export default CreateForm